var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "webContent flex df cf" }, [
    _c("div", { staticClass: "detail" }, [
      _c("div", { staticClass: "title" }, [
        _c("i", { class: _vm.type }),
        _vm._v(_vm._s(_vm.title))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "txt", domProps: { innerHTML: _vm._s(_vm.txt) } },
        [_vm._v(_vm._s(_vm.txt))]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "tool df hao" }, [
        _c("div", { staticClass: "download" }, [
          _vm._v(_vm._s(_vm.downloadCount) + "次下载")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "collect" }, [
          _vm._v(_vm._s(_vm.collectCount) + "人收藏")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex" }),
        _vm._v(" "),
        _c("div", { staticClass: "date" }, [_vm._v(_vm._s(_vm.date))]),
        _vm._v(" "),
        _c("div", { staticClass: "user" }, [_vm._v(_vm._s(_vm.user))])
      ])
    ]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "end df war hao" }, [
      _c("div", { staticClass: "downloadBtn" }, [_vm._v("下载")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44816299", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44816299","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/material/detail/detail.vue
// module id = null
// module chunks = 